import { render, staticRenderFns } from "./IBMExtraInfoDetailsForm.vue?vue&type=template&id=026555d2&scoped=true&"
import script from "./IBMExtraInfoDetailsForm.vue?vue&type=script&lang=js&"
export * from "./IBMExtraInfoDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./IBMExtraInfoDetailsForm.vue?vue&type=style&index=0&id=026555d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026555d2",
  null
  
)

export default component.exports